import React from "react";
import { useHistory } from "react-router";
import { Typography } from "@material-ui/core";

const MenuLink = ({
  title = "",
  relative,
  absolute = "/",
  external = false,
  fontWeight = "normal",
  variant = "inherit",
}) => {
  const navigate = useHistory();

  const onClick = (): void => {
    if (!external) {
      navigate.push(relative);
      return;
    }
    window.location.href = absolute;
  };
  return (
    <div className="hoverable-component" onClick={onClick}>
      <Typography
        variant={variant}
        style={{
          fontWeight,
        }}
        className="break-word-text pop-over-menu-link"
        color="primary"
      >
        {title}
      </Typography>
    </div>
  );
};

export default MenuLink;
